import styled from 'styled-components';

interface IconWrapperStyled {
  disabled?: boolean;
}

const IconWrapper = styled.div<IconWrapperStyled>`
  display: flex;
  border-radius: 6px;
  border: 1px solid #CACACA;
  opacity: ${props => props.disabled ? 0.5 : 1};
  padding: 7px;
`;

export default IconWrapper;
